"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subjects = exports.mapping = exports.KEYS = exports.HS_VALUES = void 0;

var _localization = _interopRequireDefault(require("./localization"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCHOOL_SUBJECTS = ['Mathe', 'Mathe Oberstufe', 'Mathe Unterstufe', 'Deutsch', 'Englisch', 'Französisch', 'Geschichte', 'Latein', 'Chemie', 'Biologie', 'Physik', 'Informatik', 'Geografie', 'Sonstiges', 'Love & Sex', 'Statistik', 'Recht', 'Technik', 'Medien', 'Sozialwiss', 'Geisteswiss', 'Spanisch', 'Italienisch', 'Wirtschaft', 'Rechnungswesen', 'Griechisch', 'Niederländisch', 'Russisch', 'Türkisch', 'Altgriechisch', 'Betriebswirtschaftslehre', 'App-Entwicklung', 'Robotik', 'Analysis', 'Programmierung', 'Sozialkunde', '11+', 'Swedish', 'Polish', 'Portuguese', 'SchoolPreparation', 'EarlySchoolDiscipline', 'Application_Training', 'Art_History', 'Chinese', 'Finance', 'Graphic_Design', 'Guitar', 'IB_Higher_Level', 'IB_Standard_Level', 'Japanese', 'Microsoft_Office', 'Photography', 'Photoshop', 'Piano', 'Presentation_Skills', 'Project_Management_Organisational_Skills', 'Recorder', 'Saxophone', 'Violine', 'Arabic', 'Korean', 'Primary', 'Math_Primary', 'Irish', 'Hebrew', 'Norwegian', 'ELA_Literacy', 'Arts', 'US_History', 'Health_Education', 'Feedback', 'Catalan', 'Valencian', 'Basque', 'Technical_drawing', 'English_Essay_Writing', 'Psychology', 'Religious_Studies', 'Science', 'Maths_Belgium', 'Chess', 'Philosophy', 'Local_Language_As_A_Second_Language'];
var NEW_SUBJECTS = [// 'Technik',
  // 'Medien',
  // 'Sozialwiss',
  // 'Geisteswiss',
];
var UNIVERSITY_SUBJECTS = SCHOOL_SUBJECTS.concat(NEW_SUBJECTS);
var categories = {
  school: SCHOOL_SUBJECTS,
  university: UNIVERSITY_SUBJECTS,
  both: UNIVERSITY_SUBJECTS,
  new: NEW_SUBJECTS
}; // maps subject keys into names

var KEYS = {
  MATH: 'Mathe',
  MATH_HIGH_LEVEL: 'Mathe Oberstufe',
  MATH_LOW_LEVEL: 'Mathe Unterstufe',
  GERMAN: 'Deutsch',
  ENGLISH: 'Englisch',
  FRENCH: 'Französisch',
  HISTORY: 'Geschichte',
  LATIN: 'Latein',
  CHEMISTRY: 'Chemie',
  BIOLOGY: 'Biologie',
  PHYSICS: 'Physik',
  INFORMATICS: 'Informatik',
  GEOGRAPHY: 'Geografie',
  OTHER: 'Sonstiges',
  LOVENSEX: 'Love & Sex',
  STATISTICS: 'Statistik',
  SPANISH: 'Spanisch',
  ITALIAN: 'Italienisch',
  BUSINESS_ECONOMICS: 'Wirtschaft',
  ACCOUNTING: 'Rechnungswesen',
  LAW: 'Recht',
  ENGINEERING: 'Technik',
  MEDIA: 'Medien',
  SOCIAL_STUDIES: 'Sozialwiss',
  HUMANITIES: 'Geisteswiss',
  GREEK: 'Griechisch',
  DUTCH: 'Niederländisch',
  RUSSIAN: 'Russisch',
  TURKISH: 'Türkisch',
  ANCIENT_GREEK: 'Altgriechisch',
  BUSINESS_ADMINISTRATION: 'Betriebswirtschaftslehre',
  APP_DEVELOPMENT: 'App-Entwicklung',
  ROBOTICS: 'Robotik',
  CALCULUS: 'Analysis',
  CODING: 'Programmierung',
  CIVICS: 'Sozialkunde',
  ELEVENPLUS: '11+',
  PORTUGUESE: 'Portuguese',
  POLISH: 'Polish',
  SWEDISH: 'Swedish',
  SCHOOLPREPARATION: 'SchoolPreparation',
  EARLYSCHOOLDISCIPLINE: 'EarlySchoolDiscipline',
  APPLICATION_TRAINING: 'Application_Training',
  ART_HISTORY: 'Art_History',
  CHINESE: 'Chinese',
  FINANCE: 'Finance',
  GRAPHIC_DESIGN: 'Graphic_Design',
  GUITAR: 'Guitar',
  IB_HIGHER_LEVEL: 'IB_Higher_Level',
  IB_STANDARD_LEVEL: 'IB_Standard_Level',
  JAPANESE: 'Japanese',
  MICROSOFT_OFFICE: 'Microsoft_Office',
  PHOTOGRAPHY: 'Photography',
  PHOTOSHOP: 'Photoshop',
  PIANO: 'Piano',
  PRESENTATION_SKILLS: 'Presentation_Skills',
  PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS: 'Project_Management_Organisational_Skills',
  RECORDER: 'Recorder',
  SAXOPHONE: 'Saxophone',
  VIOLINE: 'Violine',
  ARABIC: 'Arabic',
  KOREAN: 'Korean',
  PRIMARY: 'Primary',
  MATH_PRIMARY: 'Math_Primary',
  IRISH: 'Irish',
  HEBREW: 'Hebrew',
  NORWEGIAN: 'Norwegian',
  ELA_LITERACY: 'ELA_Literacy',
  ARTS: 'Arts',
  US_HISTORY: 'US_History',
  HEALTH_EDUCATION: 'Health_Education',
  FEEDBACK: 'Feedback',
  CATALAN: 'Catalan',
  VALENCIAN: 'Valencian',
  BASQUE: 'Basque',
  TECHNICAL_DRAWING: 'Technical_drawing',
  ENGLISH_ESSAY_WRITING: 'English_Essay_Writing',
  PSYCHOLOGY: 'Psychology',
  RELIGIOUS_STUDIES: 'Religious_Studies',
  SCIENCE: 'Science',
  MATHS_BELGIUM: 'Maths_Belgium',
  CHESS: 'Chess',
  PHILOSOPHY: 'Philosophy',
  LOCAL_LANGUAGE_AS_A_SECOND_LANGUAGE: 'Local_Language_As_A_Second_Language'
}; // internal hubspot subject values

exports.KEYS = KEYS;
var HS_VALUES = {
  MATH: 'Mathe',
  MATH_HIGH_LEVEL: 'Mathe OS',
  MATH_LOW_LEVEL: 'Mathe US',
  GERMAN: 'Deutsch',
  ENGLISH: 'Englisch',
  FRENCH: 'Französisch',
  HISTORY: 'Geschichte',
  LATIN: 'Latein',
  CHEMISTRY: 'Chemie',
  BIOLOGY: 'Biologie',
  PHYSICS: 'Physik',
  INFORMATICS: 'Informatik',
  GEOGRAPHY: 'Geografie',
  OTHER: 'Sonstiges',
  LOVENSEX: 'Love & Sex',
  STATISTICS: 'Statistik',
  SPANISH: 'Spanisch',
  ITALIAN: 'Italienisch',
  BUSINESS_ECONOMICS: 'Wirtschaft',
  ACCOUNTING: 'Rechnungswesen',
  LAW: 'Recht',
  ENGINEERING: '(Elektro)Technik',
  MEDIA: 'Medien',
  SOCIAL_STUDIES: 'Sozialwiss',
  HUMANITIES: 'Geisteswiss',
  GREEK: 'Griechisch',
  DUTCH: 'Niederländisch',
  RUSSIAN: 'Russisch',
  TURKISH: 'Türkisch',
  ANCIENT_GREEK: 'Altgriechisch',
  BUSINESS_ADMINISTRATION: 'Business Administration',
  APP_DEVELOPMENT: 'App Development',
  ROBOTICS: 'Robotics',
  CALCULUS: 'Calculus',
  CODING: 'Coding',
  CIVICS: 'Civics',
  ELEVENPLUS: '11+',
  PORTUGUESE: 'Portuguese',
  POLISH: 'Polish',
  SWEDISH: 'Swedish',
  SCHOOLPREPARATION: 'SchoolPreparation',
  EARLYSCHOOLDISCIPLINE: 'EarlySchoolDiscipline',
  APPLICATION_TRAINING: 'Application training',
  ART_HISTORY: 'Art history',
  CHINESE: 'Chinese',
  FINANCE: 'Financial literacy',
  GRAPHIC_DESIGN: 'Graphic design',
  GUITAR: 'Guitar',
  IB_HIGHER_LEVEL: 'International Baccalaureate (IB) - higher level',
  IB_STANDARD_LEVEL: 'International Baccalaureate (IB) - lower level',
  JAPANESE: 'Japanese',
  MICROSOFT_OFFICE: 'Microsoft Office Tools',
  PHOTOGRAPHY: 'Photography',
  PHOTOSHOP: 'Photoshop',
  PIANO: 'Piano',
  PRESENTATION_SKILLS: 'Presentation skills',
  PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS: 'Project management & organisational skills',
  RECORDER: 'Recorder',
  SAXOPHONE: 'Saxophone',
  VIOLINE: 'Violin',
  ARABIC: 'Arabic',
  KOREAN: 'Korean',
  PRIMARY: 'Primary School',
  MATH_PRIMARY: 'Maths Primary',
  IRISH: 'Irish',
  HEBREW: 'Hebrew',
  NORWEGIAN: 'Norwegian',
  ELA_LITERACY: 'ELA_Literacy',
  ARTS: 'Arts',
  US_HISTORY: 'US_History',
  HEALTH_EDUCATION: 'Health_Education',
  FEEDBACK: 'Feedback',
  CATALAN: 'Catalan',
  VALENCIAN: 'Valencian',
  BASQUE: 'Basque',
  TECHNICAL_DRAWING: 'Technical_Drawing',
  ENGLISH_ESSAY_WRITING: 'English_Essay_Writing',
  PSYCHOLOGY: 'Psychology',
  RELIGIOUS_STUDIES: 'Religious_Studies',
  SCIENCE: 'Science',
  MATHS_BELGIUM: 'Maths_Belgium',
  CHESS: 'Chess',
  PHILOSOPHY: 'Philosophy',
  LOCAL_LANGUAGE_AS_A_SECOND_LANGUAGE: 'Local_Language_As_A_Second_Language'
}; // tl-selfserve-app

exports.HS_VALUES = HS_VALUES;
var HS_VALUES_TRIAL_SESSION_SUBJECTS = {
  MATH: 'Mathe',
  ENGLISH: 'Englisch',
  GERMAN: 'Deutsch',
  FRENCH: 'Französisch',
  SPANISH: 'Spanisch',
  PHYSICS: 'Physik',
  CHEMISTRY: 'Chemie',
  BIOLOGY: 'Biologie',
  DUTCH: 'Dutch',
  FITNESS: 'Fitness',
  // HUMANITIES: 'Geisteswiss',
  GEOGRAPHY: 'Geografie',
  HISTORY: 'Geschichte',
  INFORMATICS: 'Informatik',
  LATIN: 'Latein',
  LOVENSEX: 'Love & Sex',
  // MEDIA: 'Medien',
  // LAW: 'Recht',
  OTHER: 'Sonstiges',
  // ENGINEERING: '(Elektro)Technik',
  BUSINESS_ECONOMICS: 'Wirtschaft',
  ITALIAN: 'Italienisch',
  // STATISTICS: 'Statistik',
  // OTHER: 'Andere', // repeated value in HS
  ACCOUNTING: 'Rechnungswesen',
  GREEK: 'Griechisch',
  TURKISH: 'Türkisch',
  // ANCIENT_GREEK: 'Altgriechisch',
  SOCIAL_STUDIES: 'Sozialwiss',
  PORTUGUESE: 'Portuguese',
  CATALAN: 'Catalan',
  BASQUE: 'Euskera',
  VALENCIAN: 'Valencian',
  RUSSIAN: 'Russisch',
  SCIENCE: 'Geisteswiss',
  POLISH: 'Polish',
  ELEVENPLUS: '11+'
};
var HS_VALUES_BOOK_NEW_TUTOR_FLOW = {
  MATH: 'Maths',
  MATH_HIGH_LEVEL: 'Maths (High level)',
  MATH_LOW_LEVEL: 'Maths (Low level)',
  GERMAN: 'German',
  ENGLISH: 'English',
  FRENCH: 'French',
  HISTORY: 'History',
  LATIN: 'Latin',
  CHEMISTRY: 'Chemistry',
  BIOLOGY: 'Biology',
  PHYSICS: 'Physics',
  INFORMATICS: 'Informatics',
  GEOGRAPHY: 'Geography',
  STATISTICS: 'Statistics',
  SPANISH: 'Spanish',
  ITALIAN: 'Italian',
  BUSINESS_ECONOMICS: 'Business and Economics',
  ACCOUNTING: 'Accounting',
  OTHER: 'Other',
  // 'FITNESS': 'FITNESS',
  // 'LOVENSEX': 'LOVENSEX',
  ENGINEERING: 'Engineering',
  HUMANITIES: 'Humanities',
  LAW: 'Law',
  MEDIA: 'Media',
  SOCIAL_STUDIES: 'Social Science',
  GREEK: 'Greek',
  DUTCH: 'Dutch',
  RUSSIAN: 'Russian',
  TURKISH: 'Turkish',
  ANCIENT_GREEK: 'Ancient Greek',
  BUSINESS_ADMINISTRATION: 'Business Administration',
  APP_DEVELOPMENT: 'App development',
  ROBOTICS: 'Robotics',
  CALCULUS: 'Calculus',
  CODING: 'Coding',
  CIVICS: 'Citizenship',
  ELEVENPLUS: '11+',
  PORTUGUESE: 'Portuguese',
  POLISH: 'Polish',
  SWEDISH: 'Swedish',
  SCHOOLPREPARATION: 'School Preperation',
  EARLYSCHOOLDISCIPLINE: 'Early School Discipline',
  APPLICATION_TRAINING: 'Application training',
  ART_HISTORY: 'Art history',
  // 'CHINESE': 'CHINESE', // 'Chinese (Cantonese)' or 'Chinese (Mandarin)' ???
  FINANCE: 'Financial literacy',
  GRAPHIC_DESIGN: 'Graphic design',
  GUITAR: 'Guitar',
  IB_HIGHER_LEVEL: 'International Baccalaureate (IB) - higher level',
  IB_STANDARD_LEVEL: 'International Baccalaureate (IB) - lower level',
  JAPANESE: 'Japanese',
  MICROSOFT_OFFICE: 'Microsoft Office Tools',
  PHOTOGRAPHY: 'Photography',
  PHOTOSHOP: 'Photoshop',
  PIANO: 'Piano',
  PRESENTATION_SKILLS: 'Presentation skills',
  PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS: 'Project management & organisational skills',
  RECORDER: 'Recorder',
  SAXOPHONE: 'Saxophone',
  VIOLINE: 'Violin',
  ARABIC: 'Arabic',
  KOREAN: 'Korean',
  PRIMARY: 'Primary School',
  MATH_PRIMARY: 'Maths Primary',
  IRISH: 'Irish',
  HEBREW: 'Hebrew',
  NORWEGIAN: 'Norwegian',
  ELA_LITERACY: 'ELA Literacy',
  ARTS: 'Arts',
  US_HISTORY: 'US History',
  HEALTH_EDUCATION: 'Health Education',
  FEEDBACK: 'Feedback',
  CATALAN: 'Catalan',
  VALENCIAN: 'Valencian',
  BASQUE: 'Basque',
  TECHNICAL_DRAWING: 'Technical_Drawing',
  ENGLISH_ESSAY_WRITING: 'English_Essay_Writing',
  PSYCHOLOGY: 'Psychology',
  RELIGIOUS_STUDIES: 'Religious_Studies',
  SCIENCE: 'Science'
};
var subjects = {
  MATH: {
    icon: 'math.svg',
    iconName: 'MathsIcon',
    gradientId: 'gradientBlue',
    white: true,
    position: 1,
    color: '#2D8FFF'
  },
  MATH_HIGH_LEVEL: {
    icon: 'math_high_level.svg',
    iconName: 'MathsIcon',
    gradientId: 'gradientBlue',
    white: true,
    position: 1,
    color: '#2D8FFF'
  },
  MATH_LOW_LEVEL: {
    icon: 'math_low_level.svg',
    iconName: 'MathsIcon',
    gradientId: 'gradientBlue',
    white: true,
    position: 2,
    color: '#2D8FFF'
  },
  MATH_PRIMARY: {
    icon: 'math_primary.svg',
    iconName: 'MathsIcon',
    gradientId: 'gradientTeal',
    white: true,
    position: 3,
    color: '#01D4CE'
  },
  PHYSICS: {
    icon: 'physics.svg',
    iconName: 'PhysicsIcon',
    gradientId: 'gradientLightPurple',
    white: true,
    position: 4,
    color: '#A111D7'
  },
  GERMAN: {
    icon: 'german.svg',
    iconName: 'GermanIcon',
    gradientId: 'gradientPurple',
    white: true,
    position: 5,
    color: '#B175FB'
  },
  ENGLISH: {
    icon: 'english.svg',
    iconName: 'EnglishIcon',
    gradientId: 'gradientRed',
    white: true,
    position: 6,
    color: '#F73B3B'
  },
  HISTORY: {
    icon: 'history.svg',
    gradientId: 'gradientGreen',
    white: false,
    position: 7,
    color: '#CB6800',
    iconName: ''
  },
  BIOLOGY: {
    icon: 'biology.svg',
    iconName: 'BiologyIcon',
    gradientId: 'gradientLime',
    white: false,
    position: 8,
    color: '#70CA74'
  },
  CHEMISTRY: {
    icon: 'chemistry.svg',
    iconName: 'ChemistryIcon',
    gradientId: 'gradientYellow',
    white: false,
    position: 9,
    color: '#F6C817'
  },
  FRENCH: {
    icon: 'french.svg',
    iconName: 'FrenchIcon',
    gradientId: 'gradientLightBlue',
    white: true,
    position: 10,
    color: '#4ECDF2'
  },
  SPANISH: {
    icon: 'spanish.svg',
    iconName: 'SpanishIcon',
    gradientId: 'gradientLightBlue',
    white: true,
    position: 11,
    color: '#AA151B'
  },
  ITALIAN: {
    icon: 'italian.svg',
    iconName: 'ItalianIcon',
    gradientId: 'gradientLightBlue',
    white: true,
    position: 12,
    color: '#008245'
  },
  INFORMATICS: {
    icon: 'informatics.svg',
    iconName: '',
    gradientId: 'gradientDarkPurple',
    white: true,
    position: 13,
    color: '#792499'
  },
  GEOGRAPHY: {
    icon: 'geography.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 14,
    color: '#F7A645',
    iconName: ''
  },
  LATIN: {
    icon: 'latin.svg',
    gradientId: 'gradientTeal',
    white: true,
    position: 15,
    color: '#01D4CE',
    iconName: ''
  },
  ACCOUNTING: {
    icon: 'accounting.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 16,
    color: '#FA6400',
    iconName: ''
  },
  BUSINESS_ECONOMICS: {
    icon: 'business_economics.svg',
    gradientId: 'gradientDarkerBlue',
    white: true,
    position: 17,
    color: '#1245A8',
    iconName: ''
  },
  STATISTICS: {
    icon: 'statistics.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 18,
    color: '#324BFF',
    iconName: ''
  },
  FITNESS: {
    icon: 'fitness.svg',
    gradientId: 'gradientCyan',
    white: false,
    position: 19,
    color: '#00CEF1',
    iconName: ''
  },
  HUMANITIES: {
    icon: 'humanities.svg',
    gradientId: 'gradientDarkPink',
    white: true,
    position: 20,
    color: '#e75480',
    iconName: ''
  },
  ENGINEERING: {
    icon: 'engineering.svg',
    gradientId: 'gradientDarkBlue',
    white: true,
    position: 21,
    color: '#1a84b8',
    iconName: ''
  },
  LAW: {
    icon: 'law.svg',
    gradientId: 'gradientDarkerPink',
    white: true,
    position: 22,
    color: '#e75480',
    iconName: ''
  },
  MEDIA: {
    icon: 'media.svg',
    gradientId: 'gradientDarkRed',
    white: true,
    position: 23,
    color: '#8b0000',
    iconName: ''
  },
  SOCIAL_STUDIES: {
    icon: 'social_studies.svg',
    gradientId: 'gradientDarkOrange',
    white: true,
    position: 24,
    color: '#ff6200',
    iconName: ''
  },
  GREEK: {
    icon: 'greek.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 25,
    color: '#2D8FFF',
    iconName: ''
  },
  DUTCH: {
    icon: 'dutch.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 26,
    color: '#F7A645',
    iconName: ''
  },
  RUSSIAN: {
    icon: 'russian.svg',
    gradientId: 'gradientDarkerBlue',
    white: true,
    position: 27,
    color: '#1245A8',
    iconName: ''
  },
  TURKISH: {
    icon: 'turkish.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 28,
    color: '#F73B3B',
    iconName: ''
  },
  ANCIENT_GREEK: {
    icon: 'ancient_greek.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 29,
    color: '#2D8FFF',
    iconName: ''
  },
  BUSINESS_ADMINISTRATION: {
    icon: 'business_administration.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 30,
    color: '#F7A645',
    iconName: ''
  },
  APP_DEVELOPMENT: {
    icon: 'app_development.svg',
    gradientId: 'gradientDarkPurple',
    white: true,
    position: 31,
    color: '#792499',
    iconName: ''
  },
  ROBOTICS: {
    icon: 'robotics.svg',
    gradientId: 'gradientDarkPurple',
    white: true,
    position: 32,
    color: '#792499',
    iconName: ''
  },
  CALCULUS: {
    icon: 'calculus.svg',
    gradientId: 'gradientTeal',
    white: true,
    position: 33,
    color: '#01D4CE',
    iconName: ''
  },
  CODING: {
    icon: 'coding.svg',
    gradientId: 'gradientDarkPurple',
    white: true,
    position: 34,
    color: '#792499',
    iconName: ''
  },
  CIVICS: {
    icon: 'civics.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 35,
    color: '#F7A645',
    iconName: ''
  },
  ELEVENPLUS: {
    icon: 'elevenplus.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 36,
    color: '#324BFF',
    iconName: ''
  },
  PORTUGUESE: {
    icon: 'portuguese.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 37,
    color: '#F7A645',
    iconName: ''
  },
  POLISH: {
    icon: 'polish.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 38,
    color: '#F73B3B',
    iconName: ''
  },
  SWEDISH: {
    icon: 'swedish.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 39,
    color: '#2D8FFF',
    iconName: ''
  },
  SCHOOLPREPARATION: {
    icon: 'schoolpreparation.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 40,
    color: '#2D8FFF',
    iconName: ''
  },
  EARLYSCHOOLDISCIPLINE: {
    icon: 'earlyschooldiscipline.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 41,
    color: '#2D8FFF',
    iconName: ''
  },
  APPLICATION_TRAINING: {
    icon: 'application_training.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 42,
    color: '#F73B3B',
    iconName: ''
  },
  ART_HISTORY: {
    icon: 'art_history.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 43,
    color: '#F73B3B',
    iconName: ''
  },
  CHINESE: {
    icon: 'chinese.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 44,
    color: '#324BFF',
    iconName: ''
  },
  FINANCE: {
    icon: 'finance.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 45,
    color: '#F73B3B',
    iconName: ''
  },
  GRAPHIC_DESIGN: {
    icon: 'graphic_design.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 46,
    color: '#F73B3B',
    iconName: ''
  },
  GUITAR: {
    icon: 'guitar.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 47,
    color: '#F7A645',
    iconName: ''
  },
  IB_HIGHER_LEVEL: {
    icon: 'ib_higher_level.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 48,
    color: '#F7A645',
    iconName: ''
  },
  IB_STANDARD_LEVEL: {
    icon: 'ib_standard_level.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 49,
    color: '#F7A645',
    iconName: ''
  },
  JAPANESE: {
    icon: 'japanese.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 50,
    color: '#324BFF',
    iconName: ''
  },
  MICROSOFT_OFFICE: {
    icon: 'microsoft_office.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 51,
    color: '#F7A645',
    iconName: ''
  },
  PHOTOGRAPHY: {
    icon: 'photography.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 52,
    color: '#F73B3B',
    iconName: ''
  },
  PHOTOSHOP: {
    icon: 'photoshop.svg',
    gradientId: 'gradientRed',
    white: true,
    position: 53,
    color: '#F73B3B',
    iconName: ''
  },
  PIANO: {
    icon: 'piano.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 54,
    color: '#F7A645',
    iconName: ''
  },
  PRESENTATION_SKILLS: {
    icon: 'presentation_skills.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 55,
    color: '#2D8FFF',
    iconName: ''
  },
  PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS: {
    icon: 'project_management.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 56,
    color: '#F7A645',
    iconName: ''
  },
  RECORDER: {
    icon: 'recorder.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 57,
    color: '#F7A645',
    iconName: ''
  },
  SAXOPHONE: {
    icon: 'saxophone.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 58,
    color: '#F7A645',
    iconName: ''
  },
  VIOLINE: {
    icon: 'violine.svg',
    gradientId: 'gradientOrange',
    white: true,
    position: 59,
    color: '#F7A645',
    iconName: ''
  },
  ARABIC: {
    icon: 'arabic.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 60,
    color: '#324BFF',
    iconName: ''
  },
  KOREAN: {
    icon: 'korean.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 61,
    color: '#324BFF',
    iconName: ''
  },
  PRIMARY: {
    icon: 'primary.svg',
    gradientId: 'gradientTeal',
    white: true,
    position: 62,
    color: '#01D4CE',
    iconName: ''
  },
  IRISH: {
    icon: 'irish.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 63,
    color: '#324BFF',
    iconName: ''
  },
  HEBREW: {
    icon: 'hebrew.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 64,
    color: '#324BFF',
    iconName: ''
  },
  NORWEGIAN: {
    icon: 'norwegian.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 65,
    color: '#324BFF',
    iconName: ''
  },
  ELA_LITERACY: {
    icon: 'ela_literacy.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 66,
    color: '#2D8FFF',
    iconName: ''
  },
  ARTS: {
    icon: 'arts.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 67,
    color: '#2D8FFF',
    iconName: ''
  },
  US_HISTORY: {
    icon: 'us_history.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 68,
    color: '#2D8FFF',
    iconName: ''
  },
  HEALTH_EDUCATION: {
    icon: 'health_education.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 69,
    color: '#2D8FFF',
    iconName: ''
  },
  FEEDBACK: {
    icon: 'feedback.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 70,
    color: '#4F5FEE',
    iconName: ''
  },
  LOVENSEX: {
    icon: 'lovensex.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 71,
    iconName: ''
  },
  CATALAN: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 72,
    color: '#105CB2',
    iconName: ''
  },
  VALENCIAN: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 73,
    color: '#F77F00',
    iconName: ''
  },
  BASQUE: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 74,
    color: '#9BC53D',
    iconName: ''
  },
  TECHNICAL_DRAWING: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 75,
    color: '#009284',
    iconName: ''
  },
  ENGLISH_ESSAY_WRITING: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 76,
    color: '#66ADFF',
    iconName: ''
  },
  PSYCHOLOGY: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 77,
    color: '#00C8B5',
    iconName: ''
  },
  RELIGIOUS_STUDIES: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 78,
    color: '#AA50B5',
    iconName: ''
  },
  SCIENCE: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 79,
    color: '#AA50B5',
    iconName: ''
  },
  MATHS_BELGIUM: {
    icon: 'other.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 80,
    color: '#4F5FEE',
    iconName: ''
  },
  CHESS: {
    icon: 'other.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 81,
    color: '#1A205A',
    iconName: ''
  },
  PHILOSOPHY: {
    icon: 'other.svg',
    gradientId: 'gradientBlue',
    white: true,
    position: 82,
    color: '#BE3B46',
    iconName: ''
  },
  LOCAL_LANGUAGE_AS_A_SECOND_LANGUAGE: {
    icon: 'other.svg',
    gradientId: 'gradientFire',
    white: true,
    position: 83,
    color: '#AA50B5',
    iconName: ''
  },
  OTHER: {
    icon: 'other.svg',
    gradientId: 'gradientPink',
    white: true,
    position: 84,
    color: '#F38FFF',
    iconName: ''
  }
}; // maps subject names to their keys

exports.subjects = subjects;
var mapping = {
  Mathe: 'MATH',
  'Mathe Oberstufe': 'MATH_HIGH_LEVEL',
  'Mathe Unterstufe': 'MATH_LOW_LEVEL',
  Deutsch: 'GERMAN',
  Englisch: 'ENGLISH',
  Französisch: 'FRENCH',
  Geschichte: 'HISTORY',
  Latein: 'LATIN',
  Chemie: 'CHEMISTRY',
  Biologie: 'BIOLOGY',
  Physik: 'PHYSICS',
  Informatik: 'INFORMATICS',
  Geografie: 'GEOGRAPHY',
  Statistik: 'STATISTICS',
  Spanisch: 'SPANISH',
  Italienisch: 'ITALIAN',
  Wirtschaft: 'BUSINESS_ECONOMICS',
  Rechnungswesen: 'ACCOUNTING',
  Sonstiges: 'OTHER',
  Fitness: 'FITNESS',
  'Love & Sex': 'LOVENSEX',
  Technik: 'ENGINEERING',
  Geisteswiss: 'HUMANITIES',
  Recht: 'LAW',
  Medien: 'MEDIA',
  Sozialwiss: 'SOCIAL_STUDIES',
  Griechisch: 'GREEK',
  Niederländisch: 'DUTCH',
  Russisch: 'RUSSIAN',
  Türkisch: 'TURKISH',
  Altgriechisch: 'ANCIENT_GREEK',
  Betriebswirtschaftslehre: 'BUSINESS_ADMINISTRATION',
  'App-Entwicklung': 'APP_DEVELOPMENT',
  Robotik: 'ROBOTICS',
  Analysis: 'CALCULUS',
  Programmierung: 'CODING',
  Sozialkunde: 'CIVICS',
  '11+': 'ELEVENPLUS',
  Maths: 'MATH_HIGH_LEVEL',
  'Maths High Level': 'MATH_HIGH_LEVEL',
  'Maths Low Level': 'MATH_LOW_LEVEL',
  German: 'GERMAN',
  English: 'ENGLISH',
  French: 'FRENCH',
  History: 'HISTORY',
  Latin: 'LATIN',
  Chemistry: 'CHEMISTRY',
  Biology: 'BIOLOGY',
  Physics: 'PHYSICS',
  Informatics: 'INFORMATICS',
  Geography: 'GEOGRAPHY',
  Business: 'BUSINESS_ECONOMICS',
  Accounting: 'ACCOUNTING',
  Italian: 'ITALIAN',
  Spanish: 'SPANISH',
  Other: 'OTHER',
  Engineering: 'ENGINEERING',
  Humanities: 'HUMANITIES',
  Law: 'LAW',
  Media: 'MEDIA',
  Social: 'SOCIAL_STUDIES',
  Greek: 'GREEK',
  Dutch: 'DUTCH',
  Russian: 'RUSSIAN',
  Turkish: 'TURKISH',
  'Ancient Greek': 'ANCIENT_GREEK',
  'Business Administration': 'BUSINESS_ADMINISTRATION',
  'App Development': 'APP_DEVELOPMENT',
  Robotics: 'ROBOTICS',
  Calculus: 'CALCULUS',
  Coding: 'CODING',
  Civics: 'CIVICS',
  Portuguese: 'PORTUGUESE',
  Polish: 'POLISH',
  Swedish: 'SWEDISH',
  SchoolPreparation: 'SCHOOLPREPARATION',
  EarlySchoolDiscipline: 'EARLYSCHOOLDISCIPLINE',
  Application_Training: 'APPLICATION_TRAINING',
  Art_History: 'ART_HISTORY',
  Chinese: 'CHINESE',
  Finance: 'FINANCE',
  Graphic_Design: 'GRAPHIC_DESIGN',
  Guitar: 'GUITAR',
  IB_Higher_Level: 'IB_HIGHER_LEVEL',
  IB_Standard_Level: 'IB_STANDARD_LEVEL',
  Japanese: 'JAPANESE',
  Microsoft_Office: 'MICROSOFT_OFFICE',
  Photography: 'PHOTOGRAPHY',
  Photoshop: 'PHOTOSHOP',
  Piano: 'PIANO',
  Presentation_Skills: 'PRESENTATION_SKILLS',
  Project_Management_Organisational_Skills: 'PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS',
  Recorder: 'RECORDER',
  Saxophone: 'SAXOPHONE',
  Violine: 'VIOLINE',
  Arabic: 'ARABIC',
  Korean: 'KOREAN',
  Primary: 'PRIMARY',
  Math_Primary: 'MATH_PRIMARY',
  Irish: 'IRISH',
  Hebrew: 'HEBREW',
  Norwegian: 'NORWEGIAN',
  ELA_Literacy: 'ELA_LITERACY',
  Arts: 'ARTS',
  US_History: 'US_HISTORY',
  Health_Education: 'HEALTH_EDUCATION',
  Feedback: 'FEEDBACK',
  Catalan: 'CATALAN',
  Valencian: 'VALENCIAN',
  Basque: 'BASQUE',
  Technical_drawing: 'TECHNICAL_DRAWING',
  English_Essay_Writing: 'ENGLISH_ESSAY_WRITING',
  Psychology: 'PSYCHOLOGY',
  Religious_Studies: 'RELIGIOUS_STUDIES',
  Science: 'SCIENCE',
  Maths_Belgium: 'MATHS_BELGIUM',
  Chess: 'CHESS',
  Philosophy: 'PHILOSOPHY',
  Local_Language_As_A_Second_Language: 'LOCAL_LANGUAGE_AS_A_SECOND_LANGUAGE'
};
exports.mapping = mapping;
var subjectWords = {
  MATH: ['mat', 'math', 'mathe', 'mathematik', 'algebra', 'trigonometrie', 'gleichungen'],
  GERMAN: ['deutsch'],
  ENGLISH: ['english'],
  FRENCH: ['französisch', 'franzoesisch'],
  HISTORY: ['geschichte'],
  LATIN: ['latein'],
  CHEMISTRY: ['chemie'],
  BIOLOGY: ['biologie', 'bio'],
  PHYSICS: ['physik'],
  INFORMATICS: ['informatik'],
  GEOGRAPHY: ['geographie', 'geo'],
  FITNESS: ['fitness', 'health', 'sport'],
  OTHER: ['sonstiges']
};
var gradients = {
  MATH: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  GERMAN: {
    deg: 144,
    colors: ['#B984FA', '#9C84FA']
  },
  ENGLISH: {
    deg: 144,
    colors: ['#FE2D2D', '#FF003B']
  },
  FRENCH: {
    deg: 325,
    colors: ['#4ECDF2', '#4ECDF2', '#33B6DC']
  },
  HISTORY: {
    deg: 144,
    colors: ['#ABCC2F', '#D9CB1A']
  },
  LATIN: {
    deg: 144,
    colors: ['#01D4CE', '#01DEA8']
  },
  CHEMISTRY: {
    deg: 325,
    colors: ['#F6AE17', '#F6C817']
  },
  BIOLOGY: {
    deg: 144,
    colors: ['#70CA74', '#90C25E']
  },
  PHYSICS: {
    deg: 144,
    colors: ['#A613DD', '#8413DD']
  },
  INFORMATICS: {
    deg: 325,
    colors: ['#4929B7', '#6229B7']
  },
  GEOGRAPHY: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  OTHER: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  BUSINESS_ECONOMICS: {
    deg: 144,
    colors: ['#3D4BF4', '#583DF4']
  },
  LAW: {
    deg: 325,
    colors: ['#C051F9', '#C245C9']
  },
  ENGINEERING: {
    deg: 144,
    colors: ['#013BFF', '#5914FB']
  },
  MEDIA: {
    deg: 144,
    colors: ['#D9006C', '#D9003A']
  },
  SOCIAL_STUDIES: {
    deg: 325,
    colors: ['#F15C22', '#F12222']
  },
  HUMANITIES: {
    deg: 325,
    colors: ['#FF5A91', '#FB769C']
  },
  GREEK: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  DUTCH: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  RUSSIAN: {
    deg: 144,
    colors: ['#3D4BF4', '#583DF4']
  },
  TURKISH: {
    deg: 325,
    colors: ['#F15C22', '#F12222']
  },
  ANCIENT_GREEK: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  BUSINESS_ADMINISTRATION: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  APP_DEVELOPMENT: {
    deg: 325,
    colors: ['#4929B7', '#6229B7']
  },
  ROBOTICS: {
    deg: 325,
    colors: ['#4929B7', '#6229B7']
  },
  CALCULUS: {
    deg: 144,
    colors: ['#01D4CE', '#01DEA8']
  },
  CODING: {
    deg: 325,
    colors: ['#4929B7', '#6229B7']
  },
  CIVICS: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  ELEVENPLUS: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  PORTUGUESE: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  POLISH: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  SWEDISH: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  SCHOOLPREPARATION: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  EARLYSCHOOLDISCIPLINE: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  APPLICATION_TRAINING: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  ART_HISTORY: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  CHINESE: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  FINANCE: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  GRAPHIC_DESIGN: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  GUITAR: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  IB_HIGHER_LEVEL: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  IB_STANDARD_LEVEL: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  JAPANESE: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  MICROSOFT_OFFICE: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  PHOTOGRAPHY: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  PHOTOSHOP: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  PIANO: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  PRESENTATION_SKILLS: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  PROJECT_MANAGEMENT_ORGANISATIONAL_SKILLS: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  RECORDER: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  SAXOPHONE: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  VIOLINE: {
    deg: 325,
    colors: ['#F99937', '#F77945']
  },
  ARABIC: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  KOREAN: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  PRIMARY: {
    deg: 325,
    colors: ['#01D4CE', '#01DEA8']
  },
  MATH_PRIMARY: {
    deg: 325,
    colors: ['#01D4CE', '#01DEA8']
  },
  IRISH: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  HEBREW: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  NORWEGIAN: {
    deg: 325,
    colors: ['#FF8FD8', '#F38FFF']
  },
  ELA_LITERACY: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  ARTS: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  US_HISTORY: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  HEALTH_EDUCATION: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  FEEDBACK: {
    deg: 325,
    colors: ['#0DA5F3', '#2D8FFF', '#2D8FFF']
  },
  LOVENSEX: {
    deg: 144,
    colors: ['#FB769C', '#FF8FD8']
  },
  CATALAN: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  VALENCIAN: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  BASQUE: {
    deg: 325,
    colors: ['#FE2D2D', '#FF003B']
  },
  TECHNICAL_DRAWING: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  ENGLISH_ESSAY_WRITING: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  PSYCHOLOGY: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  RELIGIOUS_STUDIES: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  SCIENCE: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  MATHS_BELGIUM: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  CHESS: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  PHILOSOPHY: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  LOCAL_LANGUAGE_AS_A_SECOND_LANGUAGE: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  },
  DEFAULT: {
    deg: 325,
    colors: ['#0EC5FF', '#495EFF']
  }
};

var createGradient = function createGradient(deg, colors) {
  var step = 100 / (colors.length - 1);
  var colorize = colors.map(function (c, i) {
    return "".concat(c, " ").concat(i * step, "%");
  }).join(', ');
  return "linear-gradient(".concat(deg, "deg, ").concat(colorize, ")");
};

var getGradient = function getGradient() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DEFAULT';
  var key = Object.keys(gradients).find(function (k) {
    return k === id;
  });
  var props = gradients[key || 'DEFAULT'];
  return createGradient(props.deg, props.colors);
};

var getColor = function getColor() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DEFAULT';
  var color = subjects[id].color;
  return color;
};

var getShortName = function getShortName(subjectId) {
  var shortKey = "".concat(subjectId, "_SHORT");

  var output = _localization.default.t(shortKey) || _localization.default.t(subjectId);

  return output;
};

var getSubjectByName = function getSubjectByName(subject) {
  var subjectId = mapping[subject];

  var name = _localization.default.t(subjectId);

  var description = _localization.default.t("".concat(subjectId, "_DESCRIPTION"), '');

  var _ref = subjects[subjectId] || {},
      icon = _ref.icon,
      iconName = _ref.iconName,
      position = _ref.position,
      gradientId = _ref.gradientId,
      white = _ref.white;

  if (!subjects[subjectId]) {
    return {};
  }

  return {
    subjectId: subjectId,
    position: position,
    name: name,
    description: description,
    icon: icon,
    iconName: iconName,
    white: white,
    gradientId: gradientId,
    color: getColor(subjectId),
    gradient: getGradient(subjectId),
    shortName: getShortName(subjectId),
    fullName: [name, description].filter(Boolean).join(' '),
    key: KEYS[subjectId],
    hsValue: HS_VALUES[subjectId],
    hsValueBookNewTutorFlow: HS_VALUES_BOOK_NEW_TUTOR_FLOW[subjectId],
    hsValueTrialSessionSubjects: HS_VALUES_TRIAL_SESSION_SUBJECTS[subjectId]
  };
};

var filterSubjects = function filterSubjects(isPremium) {
  return function (subject) {
    return subject && subject.subjectId && subject.subjectId !== 'LOVENSEX' && (subject && subject.subjectId && subject.subjectId === 'FEEDBACK' ? isPremium : true);
  };
};

var subjectItems = function subjectItems() {
  var audience = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'school';
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isPremium = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (language !== null) _localization.default.changeLanguage(language);
  return (categories[audience.toLowerCase()] || categories.school).map(getSubjectByName).filter(filterSubjects(isPremium)).sort(function (a, b) {
    return a.position - b.position;
  });
};

var getSubjectByAny = function getSubjectByAny(value, lang) {
  return subjectItems('both', lang).find(function (i) {
    return value === i.subjectId || value === i.fullName || value === i.shortName || value === i.key;
  });
};
/**
 * Get the properly translated subject or return original.
 * @param {String} subject
 * @param {String} language
 * @returns {String}
 */


var getSubjectLocalized = function getSubjectLocalized(subject, language) {
  var subjectTranslation = getSubjectByAny(subject, language);

  if (subjectTranslation && subjectTranslation.name) {
    return subjectTranslation.name;
  }

  return subject;
};
/**
 * Get the translated subject or return original if translation not available.
 * @param {String} subject
 * @param {String} language
 * @returns {String} translated language
 */


var getSubjectTranslation = function getSubjectTranslation(subject, language) {
  if (language !== null) _localization.default.changeLanguage(language);
  var subjectId = mapping[subject];

  var translated = _localization.default.t(subjectId);

  return translated || subject;
};

var subjectsByCountry = {
  NL: ['MATH', 'ENGLISH', 'PHYSICS', 'BIOLOGY', 'DUTCH', 'CHEMISTRY', 'SPANISH', 'GERMAN', 'FRENCH', 'BUSINESS_ECONOMICS', 'HISTORY', 'GEOGRAPHY', 'LATIN', 'GREEK', 'INFORMATICS', 'OTHER'],
  ES: ['MATH', 'ENGLISH', 'SPANISH', 'PHYSICS', 'CHEMISTRY', 'SOCIAL_STUDIES', 'HISTORY', 'BIOLOGY', 'FRENCH', 'ITALIAN', 'GERMAN', 'PORTUGUESE', 'LATIN', 'GREEK', 'CATALAN', 'BASQUE', 'VALENCIAN', 'BUSINESS_ECONOMICS', 'GEOGRAPHY', 'ACCOUNTING', 'OTHER'],
  GR: ['ENGLISH', 'SPANISH', 'MATH', 'GERMAN', 'FRENCH', 'ITALIAN', 'PHYSICS', 'CHEMISTRY', 'GREEK', 'INFORMATICS', 'RUSSIAN', 'OTHER'],
  TR: ['ENGLISH', 'MATH', 'PHYSICS', 'CHEMISTRY', 'SCIENCE', 'GERMAN', 'FRENCH', 'SPANISH', 'TURKISH', 'BIOLOGY', 'OTHER'],
  PL: ['MATH', 'PHYSICS', 'CHEMISTRY', 'ENGLISH', 'POLISH', 'GERMAN', 'SPANISH', 'FRENCH', 'BIOLOGY', 'HISTORY', 'ITALIAN', 'INFORMATICS', 'OTHER'],
  GB: ['MATH', 'ENGLISH', 'BIOLOGY', 'CHEMISTRY', 'PHYSICS', 'ELEVENPLUS', 'FRENCH', 'SPANISH', 'HISTORY', 'GEOGRAPHY', 'INFORMATICS', 'OTHER'],
  FR: ['MATH', 'FRENCH', 'ENGLISH', 'PHYSICS', 'BIOLOGY', 'CHEMISTRY', 'GERMAN', 'SPANISH', 'HISTORY', 'GEOGRAPHY', 'INFORMATICS', 'OTHER'],
  IT: ['BIOLOGY', 'CHEMISTRY', 'BUSINESS_ECONOMICS', 'PHYSICS', 'FRENCH', 'GREEK', 'ENGLISH', 'INFORMATICS', 'ITALIAN', 'LATIN', 'MATH', 'SPANISH', 'OTHER', 'GERMAN'],
  DACH: ['BIOLOGY', 'CHEMISTRY', 'GERMAN', 'ENGLISH', 'FRENCH', 'GEOGRAPHY', 'HISTORY', 'INFORMATICS', 'LATIN', 'MATH', 'PHYSICS', 'ACCOUNTING', 'SPANISH', 'BUSINESS_ECONOMICS', 'OTHER']
};

var getSubjectsByCountry = function getSubjectsByCountry(country, language) {
  var c = country.toUpperCase();

  if (Object.keys(subjectsByCountry).includes(c)) {
    return subjectsByCountry[c].map(function (subjectId) {
      return {
        label: getSubjectLocalized(subjectId, language),
        value: subjectId,
        hsValue: HS_VALUES_TRIAL_SESSION_SUBJECTS[subjectId],
        key: subjectId
      };
    });
  } // default DACH


  return subjectsByCountry.DACH.map(function (subjectId) {
    return {
      label: getSubjectLocalized(subjectId, language),
      value: subjectId,
      hsValue: HS_VALUES_TRIAL_SESSION_SUBJECTS[subjectId],
      key: subjectId
    };
  });
};

module.exports = {
  subjects: Object.values(KEYS).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }),
  mapping: mapping,
  HS_VALUES: HS_VALUES,
  subjectWords: subjectWords,
  subjectItems: subjectItems,
  getSubjectByName: getSubjectByName,
  getSubjectByAny: getSubjectByAny,
  getSubjectLocalized: getSubjectLocalized,
  getSubjectTranslation: getSubjectTranslation,
  subjectMapping: mapping,
  hsSubjectsMapping: HS_VALUES,
  getSubjectsByCountry: getSubjectsByCountry
};